import fr from 'facet-rest';
import IncomeStepOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeStep/MetaOverride';

export const IncomeSalaryPayStubDetailsOverride = fr.metaOverride({ base: IncomeStepOverride })
  .nameOverride(['netEarnings', 'grossEarnings', 'annualGross'], {
    _disregardIsInvalid: true,
  });
